import React, {useState, useEffect} from 'react'
import {
    Box,
    Flex,
    useMultiStyleConfig,
    Button,
    Link as ChakraLink,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import ListMenuPopover from './list-menu-popover'
import {getGlobalLink} from '../../utils/contentstack-utils'
import {useGetCategoriesData} from '../../custom-api/hooks/use-get-categories-data'
import {useIntl} from 'react-intl'
import {useGetMainMenu} from '../../custom-api/hooks/use-get-main-menu'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {remCalc} from '../../theme/_utils'

const ListMenu = () => {
    const style = useMultiStyleConfig('BraunMenu', {})
    const listMenu = style?.listMenu || {}
    const intl = useIntl()
    const {locale} = useMultiSite()

    const [selectedMenuItem, setSelectedMenuItem] = useState(null)
    const [ariaBusy, setAriaBusy] = useState(true)
    const categoryData = useGetCategoriesData()

    useEffect(() => {
        setAriaBusy(false)
    }, [])

    const {data} = useGetMainMenu('braun_')

    return (
        <nav
            id="list-menu"
            aria-label={intl.formatMessage({
                id: 'list_menu.nav.assistive_msg',
                defaultMessage: 'Main navigation',
            })}
            aria-busy={ariaBusy}
            aria-live="polite"
            aria-atomic="true"
        >
            {data && categoryData && (
                <Flex {...listMenu.listContainer} className="menu-list-container">
                    {data?.primarycategories?.map((primarycategory) => {
                        const {url, label, isAbsolute} = getGlobalLink({
                            link: primarycategory.first_level_category,
                            categoriesData: categoryData,
                            locale: locale?.alias,
                        })
                        return (
                            <Box
                                key={primarycategory.uid}
                                {...listMenu.listMenuTriggerContainer}
                                color={primarycategory?.label_hex_color}
                                onMouseEnter={() => setSelectedMenuItem(primarycategory.uid)}
                            >
                                {isAbsolute ? (
                                    <ChakraLink
                                        href={url}
                                        {...(isAbsolute
                                            ? {target: '_blank', rel: 'noopener noreferrer'}
                                            : {})}
                                        {...listMenu.categoryTitle}
                                        color={
                                            primarycategory?.uid === selectedMenuItem
                                                ? 'text.tertiary'
                                                : 'text.inverse'
                                        }
                                        target={'_blank'}
                                        rel={'noopener noreferrer'}
                                        textDecoration="none"
                                        _hover={{textDecoration: 'none'}}
                                        _focusVisible={{
                                            border: remCalc(3),
                                            borderStyle: 'solid',
                                            borderColor: 'button.border.accessibility-blue-dark',
                                            outline: 'unset',
                                            boxShadow: 'unset',
                                        }}
                                    >
                                        {label}
                                    </ChakraLink>
                                ) : (
                                    <Button
                                        as="a"
                                        {...listMenu.categoryTitle}
                                        color={
                                            primarycategory?.uid === selectedMenuItem
                                                ? 'text.tertiary'
                                                : 'text.inverse'
                                        }
                                        _focusVisible={{
                                            border: remCalc(3),
                                            borderStyle: 'solid',
                                            borderColor: 'button.border.accessibility-blue-dark',
                                            outline: 'unset',
                                            boxShadow: 'unset',
                                        }}
                                    >
                                        {label}
                                    </Button>
                                )}
                                <ListMenuPopover
                                    key={primarycategory.uid + '-popover'}
                                    primarycategory={primarycategory}
                                    selectedMenuItem={selectedMenuItem}
                                    setSelectedMenuItem={setSelectedMenuItem}
                                    first_level_image_section={
                                        primarycategory.first_level_image_section
                                    }
                                    categoryData={categoryData}
                                />
                            </Box>
                        )
                    })}
                </Flex>
            )}
        </nav>
    )
}

ListMenu.displayName = 'ListMenu'
export {ListMenu}
